<template>
    <button
        :class="appointment.type"
        class="z-10 button item"
        @click.stop="show"
        :style="style"
    >
        <svg
            fill="currentColor"
            viewBox="0 0 20 20"
            class="w-4 h-4 remove"
            @click.stop="remove"
        >
            <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
            ></path>
        </svg>
        <span class="resizer top"></span>
        <span
            class="title padding"
            v-if="check_examinations"
            @click.stop="examination"
        >
            <svg
                fill="currentColor"
                viewBox="0 0 20 20"
                class="w-3 h-3"
            >
                <path
                    fill-rule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clip-rule="evenodd"
                ></path>
            </svg>
            {{ appointment.title }}
        </span>
        <span
            class="title padding"
            v-if="!check_examinations"
        >
            <svg
                fill="currentColor"
                viewBox="0 0 20 20"
                class="w-4 h-4"
            >
                <path
                    fill-rule="evenodd"
                    d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                    clip-rule="evenodd"
                ></path>
            </svg>
            {{ appointment.title }}
        </span>
        <span class="resizer bottom"></span>
    </button>
</template>
<script type="text/javascript">
import { mapState } from "vuex";

export default {
    props: {
        appointment: {
            required: true
        }
    },
    data: () => {
        return {
            cellHeight: 11
        };
    },
    computed: {
        ...mapState("app", ["user"]),
        style() {
            return `height: calc(3rem * ${this.appointment.duration /
                30} - 4px)`;
        }
    },
    methods: {
        check_examinations() {
            if (
                this.appointment.type == "examination" &&
                this.user.authorizations !== undefined &&
                (_.indexOf(this.user.authorizations.patient, "ALL") > -1 ||
                    _.indexOf(
                        this.user.authorizations.patient,
                        "EXAMINATIONS"
                    ) > -1)
            ) {
                return true;
            }
            return false;
        },
        show() {
            this.$emit("select", { id: this.appointment.id });
        },
        examination() {
            this.$router.push(
                "/patients/" +
                    this.appointment.record_id +
                    "/examination/" +
                    this.appointment.id
            );
        },
        remove() {
            if (confirm("Sicuro di voler cancellare l'appuntamento?")) {
                this.$emit("remove", { id: this.appointment.id });
            }
        }
    }
};
</script>
